import { render, staticRenderFns } from "./AdvancedTable.vue?vue&type=template&id=f2d60e82&"
import script from "./AdvancedTable.vue?vue&type=script&lang=js&"
export * from "./AdvancedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports